import React, { Component } from 'react'
import './contact.css';
import Map from '../../containers/Map/Map';
import EmailForm from '../../containers/EmailForm/EmailForm';
import styles from './contact.css';

export default class Contact extends Component {
  render() {
    return (
      <div>
        <h1 id='contact-header'>Contact</h1>
        <div id='email-contact'>
        </div>
        <EmailForm/>
        <div className={styles.contact}>
          <div className={styles.data}>
            <div className={styles.address}>
              <h2>Contact Data</h2>
              <p><span>Address: </span>Fryderyka Chopina 45/1, Sopot</p>
              <p><span>Phone number: </span> 535 213 221</p>
            </div>
            <div className={styles.openHours}>
              <h2>Open hours</h2>
              <table>
                <tr>
                  <th>Day</th>
                  <th>Time</th>
                </tr>
                <tr>
                  <td>Monday - Friday</td>
                  <td>9:00 - 18:00</td>
                </tr>
                <tr>
                  <td>Saturday</td>
                  <td>12:00 - 22:00</td>
                </tr>
                <tr>
                  <td>Sunday</td>
                  <td>12:00 - 20:00</td>
                </tr>
              </table>
            </div>
          </div>
          <div className={styles.map}>
            <Map />
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Contact/Contact.js